import { useEffect } from 'react';

export function useKeyboardShortcut(key: string, callback: () => void, deps: any[] = []) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key.toLowerCase() === key.toLowerCase()) {
        event.preventDefault();
        callback();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [key, ...deps]);
}

export function handleEnterAsTab(event: React.KeyboardEvent) {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    const form = event.currentTarget.form;
    if (form) {
      const elements = Array.from(form.elements) as HTMLElement[];
      const currentIndex = elements.indexOf(event.currentTarget as HTMLElement);
      const nextElement = elements[currentIndex + 1];

      if (nextElement && 'focus' in nextElement) {
        nextElement.focus();
      }
    }
  }
}

export function focusNextElement() {
  const focusableElements = Array.from(
    document.querySelectorAll(
      'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
    )
  ) as HTMLElement[];

  const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);
  const nextElement = focusableElements[currentIndex + 1];

  if (nextElement) {
    nextElement.focus();
  }
}

export function focusPreviousElement() {
  const focusableElements = Array.from(
    document.querySelectorAll(
      'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
    )
  ) as HTMLElement[];

  const currentIndex = focusableElements.indexOf(document.activeElement as HTMLElement);
  const previousElement = focusableElements[currentIndex - 1];

  if (previousElement) {
    previousElement.focus();
  }
}
